module.exports = __webpack_public_path__ + "img/gartek-services-due-diligence-studies-safe-team.d3d0e48c.png";